import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { appContext } from '../../Context/appProvider'
import { useForm } from 'react-hook-form';

export default function AddInstructor() {
     const [uploading, setUploading] = useState(false)
     const [sources, setSources] = useState()
     const [files, setFiles] = useState([])
     const [name, setName] = useState(null)
     const fileRef = useRef()
     const {setNotification} = useContext(appContext)
     const { register, handleSubmit, watch, formState: { errors, isSubmitting, isDirty, isValid } } = useForm();

     const uploadImage = (event) => {
        setFiles([event.target.files[0]])
     }
     console.log(isValid)

     const submit = (data) => {
        return new Promise((resolve, reject) => {
            axios(baseUrl + path.createInstructor, {
                method: 'post',
                data: {
                    ...data,
                    profile: sources
                }
            }).then(response => {
                resolve(true)
                if(response.data.success){
                    setNotification({
                        message: 'Instructor successfully created!',
                        visible: true,
                        type: 'success'
                    })
                } else {
                    setNotification({
                        message: response.data.message,
                        visible: true,
                        type: 'error'
                    })
                }
            }).catch(e => {
                console.log(e)
                resolve(true)
                setNotification({
                    message: 'Unkown error occured!',
                    visible: true,
                    type: 'error'
                })
            })
        })
     }

    return (
    <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4'>
        <h2 className='text-black text-[18px] font-bold'>Create Instructor</h2>
        <div className='flex flex-col gap-3'>
            <form onSubmit={handleSubmit(submit)} className='flex flex-col gap-3 w-fit'>
                <div className='grid grid-cols-2 w-fit gap-x-5 gap-y-5'>
                    <input {...register('firstName', {required: true})} placeholder='First Name' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <input {...register('lastName', {required: true})} placeholder='Last Name' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <input {...register('email', {required: true})} placeholder='Email' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <input {...register('password')} placeholder='Password' type='password' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <div className='flex flex-col gap-2'>
                        <p className='text-[14px] text-black'>Profile Picture</p>
                        <div className='flex gap-2 items-center'>
                            <input ref={fileRef} onChange={uploadImage} type='file' className='border-solid border-[1px] border-[#00000040] p-2' />
                            <button onClick={() => fileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white`}>Change</button>
                        </div>
                        <div className='flex flex-wrap gap-2'>
                            {files.map(file => (
                                <UploadItem file={file} setUploading={setUploading} setSources={setSources} />
                            ))}
                        </div>
                    </div>
                    <input {...register('shortBio', {required: true})} placeholder='Short Bio' type='text' className='h-fit border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <textarea {...register('longBio', {required: true})} placeholder='Long Bio' cols={3} rows={3} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <button disabled={isSubmitting || !isValid || !sources} type='submit' className={`${(!sources || !isValid) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] w-full p-3 flex items-center justify-center h-fit`}>
                        {isSubmitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Save'}
                    </button>
                </div>
                
                
            </form>
        </div>
    </div>
    )
}

function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        axios(baseUrl + path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                setLoading(false)
                setSource(response.data.source)
                setSources(response.data.source)
            }
        })
    }, [file])

    return (
        <div className='w-[50px] h-[50px] border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> ): (
                    <img src={baseUrl + source} alt='source' className='w-full h-full object-contain'  />
                )}
        </div>
    )
}